<template>
  <div class="chat_info d-grid grid-col-max-1 gap-4 w-100" @click="handleClick">
    <ChatAvatar
      :src="params.displayData.photo"
      :text="params.displayData.name"
      :size="avatarSize"
      :online="interlocutorUser && interlocutorUser.wasOnlineAt === 'online'"
      class="align-self-center unselectable"
      :isDelete="interlocutorUser && interlocutorUser.isUserDelete"
    />
    <div class="align-self-center">
      <div class="chat_info__title secondary--text text--darken-2 overflow-hidden f14 fw400">
        {{ params.displayData.name }}
      </div>
      <div v-if="params.displayData.info" class="f12 fw400 primary--text text--lighten-2 mt-1">
        {{ params.displayData.info }}
      </div>
      <div v-if="showOnlineStatus" class="f13 mt-2 secondary--text text--darken-2">
        {{ showOnlineStatus }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ChatAvatar from 'components/chat/ChatAvatar'
export default {
  name: 'ChatInfo',
  components: { ChatAvatar },
  props: {
    params: Object,
    index: Number,
    avatarSize: { type: Number, default: 75 },
    chatTranslations: Object,
  },
  data() {
    return {
      interval: null,
      showTimeInfo: null,
    }
  },
  created() {
    this.onStartInterval()
  },
  destroyed() {
    this.offInterval()
  },
  watch: {
    interlocutorUser() {
      this.onStartInterval()
    },
  },
  computed: {
    ...mapState(['chatApiDomain']),
    ...mapGetters(['apiDomain']),
    ...mapGetters('user', ['userData']),
    interlocutorUser() {
      return this.params.type === 'PERSONAL' && this.params.interlocutorUser
        ? this.params.interlocutorUser.user
        : null
    },
    interlocutorUserOnlineStatus() {
      return (
        this.interlocutorUser !== null &&
        (this.interlocutorUser.wasOnlineAt
          ? this.interlocutorUser.wasOnlineAt === 'online'
            ? this.chatTranslations.online
            : this.localStorage.translations.pages['setting-users'].tables['visit'] +
              ' - ' +
              this.showTimeInfo
          : '')
      )
    },
    showOnlineStatus() {
      const textOne = this.chatTranslations.typing_user.firstLetterToLowerCase() + '...'
      const textTwo = this.chatTranslations.typing_users.firstLetterToLowerCase() + '...'
      const textTree = this.chatTranslations.and_more
      const onlineParticipantsLength = this.params.participants.filter(
        (i) => i.user.wasOnlineAt === 'online',
      ).length
      const usersIsTypingArray =
        this.params.usersIsTyping && Object.values(this.params.usersIsTyping)
      const usersIsTypingGroupText = () => {
        if (usersIsTypingArray.length > 0) {
          const getUserFullName = (user) => user.first_name + ' ' + user.last_name
          const userOne = usersIsTypingArray[0]
          const userOneFullName = getUserFullName(userOne)
          if (usersIsTypingArray.length === 1) {
            return userOneFullName + ' ' + textOne
          } else if (usersIsTypingArray.length > 1) {
            const userTwo = usersIsTypingArray[1]
            const userTwoFullName = getUserFullName(userTwo)
            return (
              userOneFullName +
              ', ' +
              userTwoFullName +
              (usersIsTypingArray.length > 2
                ? ', ' + textTree + ' ' + (usersIsTypingArray.length - 2)
                : '') +
              ' ' +
              textTwo
            )
          }
        }
      }
      return this.params.type === 'PERSONAL'
        ? usersIsTypingArray?.length &&
          this.params.usersIsTyping[this.params.interlocutorUser.user.id]
          ? textOne
          : this.interlocutorUserOnlineStatus
        : usersIsTypingArray?.length
        ? usersIsTypingGroupText()
        : `${this.localStorage.translations.pages.setting.pages['polzovateli']}: ${this.params.participants.length}` +
          (onlineParticipantsLength > 1
            ? `, ${this.chatTranslations.online}: ${onlineParticipantsLength}`
            : '')
    },
  },
  methods: {
    handleClick(v) {
      this.$emit('click')
    },
    onStartInterval() {
      this.offInterval()
      if (this.interlocutorUser !== null && this.interlocutorUser.wasOnlineAt !== 'online') {
        this.showTimeInfo = this.$dayjs(this.interlocutorUser.wasOnlineAt).fromNow()
        this.interval = setInterval(() => {
          this.showTimeInfo = this.$dayjs(this.interlocutorUser.wasOnlineAt).fromNow()
        }, 60000)
      } else {
        this.showTimeInfo = null
      }
    },
    offInterval() {
      if (this.interval !== null) {
        clearInterval(this.interval)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chat_info {
  position: relative;
  &__title {
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
